<template>
  <div class="admin-shell">
    <div v-if="mobileNavOpen" class="nav-backdrop" @click="mobileNavOpen = false"></div>
    <aside class="sidebar" :class="{ 'is-open': mobileNavOpen }">
      <div class="brand">
        <div class="brand-mark">
          <span></span>
          <span></span>
          <span></span>
        </div>
        <div>
          <strong>Message Gateway</strong>
          <small>MESSAGE OPS</small>
        </div>
      </div>

      <div class="environment-pill">
        <i></i>
        {{ environmentLabel }} ENVIRONMENT
      </div>

      <nav class="nav-list" @click="mobileNavOpen = false">
        <template v-if="standardMenuVisible">
        <router-link to="/dashboard">
          <i class="el-icon-data-analysis"></i>
          <span>Dashboard</span>
        </router-link>
        <router-link to="/messages">
          <i class="el-icon-document"></i>
          <span>Sending Records</span>
        </router-link>
        <router-link to="/sms-dashboard">
          <i class="el-icon-data-line"></i>
          <span>SMS Dashboard</span>
        </router-link>
        <router-link to="/push">
          <i class="el-icon-bell"></i>
          <span>Push Operations</span>
        </router-link>
        <router-link to="/voice-strategies">
          <i class="el-icon-setting"></i>
          <span>Voice Strategies</span>
        </router-link>
        <router-link to="/providers">
          <i class="el-icon-connection"></i>
          <span>Provider Status</span>
        </router-link>
        <div class="nav-group">
          <span class="nav-group-title"><i class="el-icon-message"></i>SMS Configuration</span>
          <router-link to="/sms-config/channels"><span>SMS Channels</span></router-link>
          <router-link to="/sms-config/senders"><span>Sender ID</span></router-link>
          <router-link to="/sms-config/templates"><span>SMS Templates</span></router-link>
          <router-link to="/sms-config/routes"><span>Sending Routes</span></router-link>
          <router-link to="/sms-config/legacy-template-channels"><span>Legacy Template Channels</span></router-link>
        </div>
        <router-link to="/callback-exceptions">
          <i class="el-icon-warning-outline"></i>
          <span>Callback Exceptions</span>
        </router-link>
        <router-link v-if="uatTestSendEnabled" to="/uat-test-send">
          <i class="el-icon-phone-outline"></i>
          <span>UAT Test Send</span>
        </router-link>
        <router-link v-if="operationsVisible" to="/operations">
          <i class="el-icon-monitor"></i>
          <span>Operations</span>
        </router-link>
        </template>
        <router-link v-if="smsRecordQueryVisible" to="/sms-record-query">
          <i class="el-icon-search"></i>
          <span>SMS Record Query</span>
        </router-link>
      </nav>

      <div class="sidebar-foot">
        <span>AI Voice / Phase 1</span>
        <small>Cross-channel fallback is disabled</small>
      </div>
    </aside>

    <main class="main-panel">
      <header class="topbar">
        <button class="mobile-nav-toggle" type="button" aria-label="Open navigation" @click="mobileNavOpen = true">
          <i class="el-icon-menu"></i>
        </button>
        <div>
          <p class="eyebrow">AI VOICE OPERATIONS</p>
          <h1>{{ pageTitle }}</h1>
        </div>
        <div class="topbar-actions">
          <div class="system-health">
            <i></i>
            Service online
          </div>
          <el-dropdown trigger="click" @command="handleCommand">
            <div class="user-chip">
              <div class="avatar">{{ userInitial }}</div>
              <div>
                <strong>{{ userName }}</strong>
                <small>{{ roleLabel }}</small>
              </div>
              <i class="el-icon-arrow-down"></i>
            </div>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="logout">Sign out</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </header>

      <section class="content-area">
        <router-view />
      </section>
    </main>
  </div>
</template>

<script>
import { getAdminCapabilities, logout } from '../api/admin'

export default {
  name: 'AdminLayout',
  data () {
    return {
      capabilities: {
        runtimeEnvironment: 'local',
        uatTestSendEnabled: false
      },
      mobileNavOpen: false
    }
  },
  computed: {
    pageTitle () {
      return this.$route.meta.title || 'Message Gateway'
    },
    userName () {
      return (this.$store.state.user && this.$store.state.user.displayName) || 'Administrator'
    },
    userInitial () {
      return this.userName.slice(0, 1).toUpperCase()
    },
    environmentLabel () {
      return (this.capabilities.runtimeEnvironment || 'local').toUpperCase()
    },
    uatTestSendEnabled () {
      return Boolean(this.capabilities.uatTestSendEnabled)
    },
    roles () {
      return (this.$store.state.user && this.$store.state.user.roles) || []
    },
    roleLabel () {
      return this.roles.join(' / ') || 'VIEWER'
    },
    operationsVisible () {
      return this.roles.includes('OPS') || this.roles.includes('ADMIN')
    },
    standardMenuVisible () {
      return this.roles.some(role => ['VIEWER', 'OPERATOR', 'OPS', 'ADMIN'].includes(role))
    },
    smsRecordQueryVisible () {
      return this.roles.includes('SMS_RECORD_QUERY') || this.roles.includes('ADMIN')
    }
  },
  async created () {
    if (!this.standardMenuVisible) return
    try {
      this.capabilities = await getAdminCapabilities()
    } catch (error) {
      this.capabilities.uatTestSendEnabled = false
    }
  },
  methods: {
    async handleCommand (command) {
      if (command !== 'logout') return
      try {
        await logout()
      } finally {
        this.$store.commit('clearSession')
        this.$router.replace('/login')
      }
    }
  }
}
</script>
